var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInverters = function SvgInverters(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit",
    d: "M19.548 2.456c.288.291.45.687.45 1.1v16.888c0 .413-.162.809-.45 1.1A1.53 1.53 0 0 1 18.46 22H5.538c-.408 0-.799-.164-1.087-.456a1.56 1.56 0 0 1-.451-1.1V3.556c0-.413.162-.809.45-1.1A1.53 1.53 0 0 1 5.539 2H18.46c.408 0 .8.164 1.088.456M20 5h2M20 19h2M2 5h2M2 19h2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinejoin: "round",
    strokeWidth: "inherit",
    d: "M8 6h8v3H8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit",
    d: "M8 14.667c.77-.4 1.5-.667 2.461-.667 1.231 0 1.847 1 3.078 1 1.174 0 1.69-.268 2.461-.667M8 17.667c.77-.4 1.5-.667 2.461-.667 1.231 0 1.847 1 3.078 1 1.174 0 1.69-.268 2.461-.667"
  })));
};
export default SvgInverters;